import { FETCH_PROMOTIONS_PER_PAGE_COUNT } from '@bo-constants/member/members';
import type { MemberPromotionFilters } from '@library/types/members/memberPromotions';
import { useGetMemberPromotionsQuery } from '@bo-services/members/memberPromotionsApi';

import { useParams } from 'react-router-dom';

export const useMemberPromotionsTable = ({
  currentPage,
  memberPromotionFilters
}: {
  currentPage: number;
  memberPromotionFilters: MemberPromotionFilters;
}) => {
  const { memberId } = useParams<{ memberId?: string }>();

  const { promotionType = '' } = memberPromotionFilters;

  const { data, isError, isFetching, isLoading } = useGetMemberPromotionsQuery(
    {
      memberId,
      page: currentPage,
      perPage: FETCH_PROMOTIONS_PER_PAGE_COUNT,
      promotionType
    },
    {
      skip: !memberId
    }
  );

  const isPromotionsLoading = isFetching || isLoading;

  const { memberPromotions = [], totalPages = 0 } = data || {};

  return {
    currentPage,
    isError,
    isLoading: isPromotionsLoading,
    memberPromotions,
    totalPages
  };
};
